<mat-form-field fxFlex>
	<input type="text" class="autoProduct" [placeholder]="placeholder" aria-label="Number" matInput
		[matAutocomplete]="auto" [(ngModel)]="AutoValue" (ngModelChange)="this.autoUpdate.next($event)"
		[disabled]="disabled" (keyup.enter)="enter($event)" (click)='openPanel()' #inputAutoComplit>
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="valueChanged()" [displayWith]="displayFn">
		<mat-option *ngFor="let option of options | async" [value]="option">
			{{option[key]}}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>